import './assets/main.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'leaflet/dist/leaflet.css'
import * as Sentry from "@sentry/vue";
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import App from './App.vue'
import router from './router'

const app = createApp(App)

Sentry.init({
    app,
    dsn: "https://dd9cd1eb661cf11461869230d0eeda61@o433582.ingest.us.sentry.io/4509174234939392"
});

// Configuration du Toast
const toastOptions = {
    position: "top-right",
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false
}

app.use(createPinia())
app.use(router)
app.use(Toast, toastOptions)

app.mount('#app')
